export const maskedAddress = (address?: string | null) => {
    if (!address) return ''
    const prefix = address.substring(0, 6)
    const suffix = address.substring(address.length - 4, address.length)
    return `${prefix} ... ${suffix}`
}
